
import camelCase from 'lodash/camelCase'
import Vue from 'vue'

/**
 * Register all the directives from the folder ./directives
 * 
 */
const requireDirectives = require.context( './directives', true, /[\w-]+\.js$/ );

requireDirectives.keys().forEach((fileName) => {
    const name = camelCase(fileName.replace(/(\.\/|\.js)/g, ''))
    const directive = requireDirectives(fileName);
    //Vue.directive(name, requireDirectives(fileName).default);
});

/**
 * Register all the plugins from the folder ./plugins
 * 
 */
const requirePlugins = require.context( './plugins', true, /[\w-]+\.js$/ );

requirePlugins.keys().forEach((fileName) => {
    const componentConfig = requirePlugins(fileName)
    const name = fileName.replace(/(\.\/|\.js)/g, '');
    const Plugin = require('./plugins/' + name).default;
    Vue.use( Plugin );
});
